module.exports = __webpack_public_path__ + "fonts/CashSans-Semibold.e887c03.woff2";